import { useState, useEffect } from 'react'

export function useScreenshotAttempt() {
  const [screenshotAttempt, setScreenshotAttempt] = useState(false)

  useEffect(() => {
    let metaDown = false
    let shiftDown = false

    const onKeyDown = (e) => {
      if (e.key === 'Meta') metaDown = true
      if (e.key === 'Shift') shiftDown = true

      if (metaDown && shiftDown) {
        setScreenshotAttempt(true)
      }
    }

    const onKeyUp = (e) => {
      if (e.key === 'Meta') metaDown = false
      if (e.key === 'Shift') shiftDown = false
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)

    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [])

  return { screenshotAttempt, setScreenshotAttempt }
}
